import type { MzcrLocale } from '@meddihub/mzcr-ui';
import { useAppContext } from '../../../Services/AppContext';
import { Languages } from '../../../Enums/Common';

/** Czech-speaking users get the MZČR services in Czech, everyone else in English. */
const CZECH_LANGUAGES: string[] = [Languages.CS, Languages.SK];

/** Language of the `@meddihub/mzcr-ui` components – follows the language of the app. */
export default function useMzcrLocale(): MzcrLocale {
	const { language } = useAppContext();

	return CZECH_LANGUAGES.includes(language) ? 'cs' : 'en';
}
